import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import {
  AddressManagerCreateActions,
  UiActions
} from '../../../store/actions';
import { DataNotClientService } from '../../../services/data-not-client.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequestAddressManagerCreate } from 'src/app/shared/interfaces';
import { RedirectService } from 'src/app/services/redirect.service';
import { ApiResponseStatus, StepsNotClientTypes } from '../../../shared/enums';
import { deparments } from '../../bfpe-common/data/deparments';
import { urbanizationTypes } from '../../bfpe-common/data/urbanizationTypes';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'lib-public-address-joint',
  templateUrl: './public-address-joint.component.html',
  styleUrls: ['../../../global.scss', './public-address-joint.component.scss']
})
export class PublicAddressJointComponent implements OnInit {
  isSameJointAccountAddress: boolean;
  urbanizationTypes: any = urbanizationTypes;
  showPanel = false;
  formData: FormGroup;
  departments: any = deparments;
  provinces: any = [];
  districts: any = [];
  step = 4;
  staticAssetsUrl = environment.staticScripts.staticAssets;
  addressManager$ = this.store.pipe(select(OnboardingProductsStore.selectors.addressManagerCreate));

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataNotClientService: DataNotClientService,
    public loadingService: LoadingService,
    public sessionService: SessionService,
    private _fb: FormBuilder,
    private redirectService: RedirectService
  ) {
    this.formData = this._fb.group({
      departmentJoint: [null, Validators.required],
      provinceJoint: [null, Validators.required],
      districtJoint: [null, Validators.required],
      streetNameJoint: ['', Validators.required],
      streetNumberJoint: [''],
      buildingNameJoint: [''],
      flatNumberJoint: [''],
      urbanizationTypeJoint: [null],
      urbanizationNameJoint: [''],
      blockNumberJoint: [''],
      lotNumberJoint: [''],
      sectorNameJoint: ['', Validators.maxLength(20)]
    });
  }

  addressManagerSuscription = this.addressManager$.subscribe(({ response, error }) => {
    // error case
    if (error != null) {
      this.redirectService.setRedirect(StepsNotClientTypes.STEP_PUBLIC_LANDING);
      this.store.dispatch(AddressManagerCreateActions.cleanState());
      this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
    }

    if (response != null &&
        (response.client.operationState.code === ApiResponseStatus.OK &&
        response.joint.operationState.code === ApiResponseStatus.OK)) {
      this.store.dispatch(AddressManagerCreateActions.cleanState());
      if (this.dataNotClientService.getAccountType() === 'Ahorro') {
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NATIONALITY }));
      } else {
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_INFORMATION_LABOR_CLIENT }));
      }
    } else if (response != null && (response.client.operationState.code !== ApiResponseStatus.OK || response.joint.operationState.code !== ApiResponseStatus.OK)) {
      this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NO_OFFER }));
    }
  });

  ngOnInit() {
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
    this.setService();

    this.formData.get('departmentJoint').valueChanges.subscribe((val) => {
      if (val) {
        this.provinces = val.provincias;
      }
      this.formData.get('provinceJoint').patchValue(null);
      this.formData.get('districtJoint').patchValue(null);
    });

    this.formData.get('provinceJoint').valueChanges.subscribe((val) => {
      if (val) {
        this.districts = val.distritos;
      }
      this.formData.get('districtJoint').patchValue(null);
    });
  }

  setService() {
    const googleAnalytics = {is_joint_account: this.dataNotClientService.isIsJointAccount()};
    this.store.dispatch(TagPage({text: 'personal-address-joint', extras: googleAnalytics}));
  }

  continue() {
    if (this.formData.invalid && !this.isSameJointAccountAddress) {
      return;
    }
    this.loadingService.loading = true;
    this.setJointData(this.isSameJointAccountAddress);

    let request: RequestAddressManagerCreate = {
      client: {
        regionCode: this.dataNotClientService.getDepartmentCode(),
        regionDescription: this.dataNotClientService.getDepartmentDescription(),
        cityCode: this.dataNotClientService.getProvinceCode(),
        cityDescription: this.dataNotClientService.getProvinceDescription(),
        communeCode: this.dataNotClientService.getDistrictCode(),
        communeDescription: this.dataNotClientService.getDistrictDescription(),
        streetName: this.dataNotClientService.getStreetName()
      },
      joint: {
        regionCode: this.dataNotClientService.getDepartmentCodeJoint(),
        regionDescription: this.dataNotClientService.getDepartmentDescriptionJoint(),
        cityCode: this.dataNotClientService.getProvinceCodeJoint(),
        cityDescription: this.dataNotClientService.getProvinceDescriptionJoint(),
        communeCode: this.dataNotClientService.getDistrictCodeJoint(),
        communeDescription: this.dataNotClientService.getDistrictDescriptionJoint(),
        streetName: this.dataNotClientService.getStreetNameJoint()
      }
    };
    // Client
    request = this.checkClientAddress(request);
    // Joint
    request = this.checkJointAddress(request);
    this.store.dispatch(AddressManagerCreateActions.getAddressManagerCreate({ request }));
  }

  checkJointAddress(request: RequestAddressManagerCreate): RequestAddressManagerCreate {
    if (this.dataNotClientService.getStreetNumberJoint()) {
      request.joint.streetNumber = this.dataNotClientService.getStreetNumberJoint();
    }
    if (this.dataNotClientService.getBuildingNameJoint()) {
      request.joint.buildingName = this.dataNotClientService.getBuildingNameJoint();
    }
    if (this.dataNotClientService.getFlatNumberJoint()) {
      request.joint.flatNumber = this.dataNotClientService.getFlatNumberJoint();
    }
    if (this.dataNotClientService.getUrbanizationTypeJoint()) {
      request.joint.urbanizationType = this.dataNotClientService.getUrbanizationTypeJoint();
    }
    if (this.dataNotClientService.getUrbanizationNameJoint()) {
      request.joint.urbanizationName = this.dataNotClientService.getUrbanizationNameJoint();
    }
    if (this.dataNotClientService.getBlockNumberJoint()) {
      request.joint.blockNumber = this.dataNotClientService.getBlockNumberJoint();
    }
    if (this.dataNotClientService.getLotNumberJoint()) {
      request.joint.lotNumber = this.dataNotClientService.getLotNumberJoint();
    }
    if (this.dataNotClientService.getSectorNameJoint()) {
      request.joint.sectorName = this.dataNotClientService.getSectorNameJoint();
    }
    return request;
  }

  checkClientAddress(request: RequestAddressManagerCreate): RequestAddressManagerCreate {
    if (this.dataNotClientService.getStreetNumber()) {
      request.client.streetNumber = this.dataNotClientService.getStreetNumber();
    }
    if (this.dataNotClientService.getBuildingName()) {
      request.client.buildingName = this.dataNotClientService.getBuildingName();
    }
    if (this.dataNotClientService.getFlatNumber()) {
      request.client.flatNumber = this.dataNotClientService.getFlatNumber();
    }
    if (this.dataNotClientService.getUrbanizationType()) {
      request.client.urbanizationType = this.dataNotClientService.getUrbanizationType();
    }
    if (this.dataNotClientService.getUrbanizationName()) {
      request.client.urbanizationName = this.dataNotClientService.getUrbanizationName();
    }
    if (this.dataNotClientService.getBlockNumber()) {
      request.client.blockNumber = this.dataNotClientService.getBlockNumber();
    }
    if (this.dataNotClientService.getLotNumber()) {
      request.client.lotNumber = this.dataNotClientService.getLotNumber();
    }
    if (this.dataNotClientService.getSectorName()) {
      request.client.sectorName = this.dataNotClientService.getSectorName();
    }
    return request;
  }

  enableSameJointAccountAddress(setData = false) {
    if (!setData) {
      this.isSameJointAccountAddress = !this.isSameJointAccountAddress;
      if (this.isSameJointAccountAddress) {
        this.formData.controls['departmentJoint'].clearValidators();
        this.formData.controls['provinceJoint'].clearValidators();
        this.formData.controls['districtJoint'].clearValidators();
        this.formData.controls['streetNameJoint'].clearValidators();
        this.formData.controls['streetNumberJoint'].clearValidators();
      } else {
        this.formData.controls['departmentJoint'].setValidators([Validators.required]);
        this.formData.controls['provinceJoint'].setValidators([Validators.required]);
        this.formData.controls['districtJoint'].setValidators([Validators.required]);
        this.formData.controls['streetNameJoint'].setValidators([Validators.required]);
        this.formData.controls['streetNumberJoint'].setValidators([Validators.required]);
      }
    }
  }

  openPanel() {
    this.showPanel = !this.showPanel;
  }

  setJointData(sameAsClient: boolean) {
    if (sameAsClient) {
      this.setSameAddressAsClient();
    } else {
      this.setJointAddress();
    }
  }

  setSameAddressAsClient() {
    this.dataNotClientService.setDepartmentCodeJoint(this.dataNotClientService.getDepartmentCode());
    this.dataNotClientService.setDepartmentDescriptionJoint(this.dataNotClientService.getDepartmentDescription());
    this.dataNotClientService.setProvinceCodeJoint(this.dataNotClientService.getProvinceCode());
    this.dataNotClientService.setProvinceDescriptionJoint(this.dataNotClientService.getProvinceDescription());
    this.dataNotClientService.setDistrictCodeJoint(this.dataNotClientService.getDistrictCode());
    this.dataNotClientService.setDistrictDescriptionJoint(this.dataNotClientService.getDistrictDescription());
    this.dataNotClientService.setStreetNameJoint(this.dataNotClientService.getStreetName());
    this.dataNotClientService.setStreetNumberJoint(this.dataNotClientService.getStreetNumber());
    this.dataNotClientService.setBuildingNameJoint(this.dataNotClientService.getBuildingName());
    this.dataNotClientService.setFlatNumberJoint(this.dataNotClientService.getFlatNumber());
    this.dataNotClientService.setUrbanizationTypeJoint(this.dataNotClientService.getUrbanizationType());
    this.dataNotClientService.setUrbanizationNameJoint(this.dataNotClientService.getUrbanizationName());
    this.dataNotClientService.setBlockNumberJoint(this.dataNotClientService.getBlockNumber());
    this.dataNotClientService.setLotNumberJoint(this.dataNotClientService.getLotNumber());
    this.dataNotClientService.setSectorNameJoint(this.dataNotClientService.getSectorName());
  }

  setJointAddress() {
    this.dataNotClientService.setDepartmentCodeJoint(this.formData.controls['departmentJoint'].value.codigo);
    this.dataNotClientService.setDepartmentDescriptionJoint(this.formData.controls['departmentJoint'].value.nombre);
    this.dataNotClientService.setProvinceCodeJoint(this.formData.controls['provinceJoint'].value.codigo);
    this.dataNotClientService.setProvinceDescriptionJoint(this.formData.controls['provinceJoint'].value.nombre);
    this.dataNotClientService.setDistrictCodeJoint(this.formData.controls['districtJoint'].value.codigo);
    this.dataNotClientService.setDistrictDescriptionJoint(this.formData.controls['districtJoint'].value.nombre);
    this.dataNotClientService.setStreetNameJoint(this.formData.controls['streetNameJoint'].value);
    // OPTIONAL INPUTS
    const streetNumber = this.formData.controls['streetNumberJoint'].value;
    const buildingNameJoint = this.formData.controls['buildingNameJoint'].value;
    const flatNumberJoint = this.formData.controls['flatNumberJoint'].value;
    const urbanizationName = this.formData.controls['urbanizationNameJoint'].value;
    const urbanizationType = this.formData.controls['urbanizationTypeJoint'].value;
    const blockNumber = this.formData.controls['blockNumberJoint'].value;
    const lotNumber = this.formData.controls['lotNumberJoint'].value;
    const sectorName = this.formData.controls['sectorNameJoint'].value;
    this.dataNotClientService.setStreetNumberJoint(streetNumber ? streetNumber : null);
    this.dataNotClientService.setBuildingNameJoint(buildingNameJoint ? buildingNameJoint : null);
    this.dataNotClientService.setFlatNumberJoint(flatNumberJoint ? flatNumberJoint : null);
    this.dataNotClientService.setUrbanizationNameJoint(urbanizationName ? urbanizationName : null);
    this.dataNotClientService.setUrbanizationTypeJoint(urbanizationType ? urbanizationType : null);
    this.dataNotClientService.setBlockNumberJoint(blockNumber ? blockNumber : null);
    this.dataNotClientService.setLotNumberJoint(lotNumber ? lotNumber : null);
    this.dataNotClientService.setSectorNameJoint(sectorName ? sectorName : null);
  }
}
